import React from "react";
import FinanceManagement from "src/pages/finance/FinanceManagement";

export default function FinancePage() {
  return <FinanceManagement />;
}
